import request from '@/utils/request';

// 获取资源列表
export function getResourceByPage(data) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/resource/page',
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资源列表失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 获取资源详情
export function getResourceById(id) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/get/${id}`,
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资源详情失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 删除资源
export function getResourceDelete(id) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/delete/${id}`,
			method: 'delete',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '删除资源失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 新增资源
export function getResourceSave(data) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/save`,
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '新增资源失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 获取资源统计信息
export function getResourceStatistics(data) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/statistics`,
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取资源统计信息失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 获取资源统计信息
export function getResourceUpdate(data) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/update`,
			method: 'put',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '更新资源失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 拆分资源
export function getResourceSplit(data) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/split`,
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '拆分资源失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 合并资源
export function getResourceMerge(data) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/merge`,
			method: 'post',
			data,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '合并资源失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 导出资源列表
export function exportResourceList(params) {
	return new Promise((resolve, reject) => {
		request({
			url: `/api/resource/export`,
			method: 'get',
			params,
			responseType: 'blob',
		})
			.then(response => {
				resolve(response);
			})
			.catch(error => {
				reject(error);
			});
	});
}
